// import media files
import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar5 from 'assets/images/avatar/avatar-5.jpg';
import Avatar7 from 'assets/images/avatar/avatar-7.jpg';
import Avatar8 from 'assets/images/avatar/avatar-8.jpg';
import Avatar9 from 'assets/images/avatar/avatar-9.jpg';
import Avatar10 from 'assets/images/avatar/avatar-10.jpg';
import Avatar11 from 'assets/images/avatar/avatar-11.jpg';
import Avatar12 from 'assets/images/avatar/avatar-12.jpg';

export const customersData = [
  {
    id: 1,
    name: 'Harold Gonzalez',
    avatar: Avatar1,
    email: 'haroldonzalez@gmail.com',
    phone: '+(000) 123465 987',
    address: '3812 Orchard Street, Bloomington, Minnesota 55431',
    location: 'Florida, United States',
    totalOrders: 2,
    totalSpent:240
  },
  {
    id: 2,
    name: 'Anthony Anderson',
    avatar: Avatar5,
    email: 'anthony@gmail.com',
    phone: '+(000) 123-456-789',
    address: '3812 Orchard Street, Bloomington, Minnesota 55431',
    location: 'California, United States',
    totalOrders: 1,
    totalSpent:199
  },
  {
    id: 3,
    name: 'Gary Faulkner',
    avatar:Avatar9,
    email: 'garyfaulkner@gmail.com',
    phone: '02227 830161',
    address: '112 Blumenstrasse 105, Bornheim, North Rhine-Westphalia, 53332',
    location: 'North Rhine, Germany',
    totalOrders: 2,
    totalSpent:240
  },
  {
    id: 4,
    name: 'Steve Nelson',
    avatar: Avatar10,
    email: 'steve_n@gmail.com',
    phone: '+(000) 123 465 987',
    address: 'Willoughby Ave, 31, Schopolo Pl, Schnapper Rock,Rotorua',
    location: 'Rotorua, New Zealand',
    totalOrders: 3,
    totalSpent:325
  },
  {
    id: 5,
    name: 'Kimberly Sullivan',
    avatar: Avatar3,
    email: 'kimberly_s@gmail.com',
    phone: '(03) 9930 4444',
    address: '215 Somerton Rd, Melbourne, Victoria, 3048',
    location: 'Gundamulda, Australia',
    totalOrders: 5,
    totalSpent:125
  },
  {
    id: 6,
    name: 'Susan Pugh',
    avatar: Avatar7,
    email: 'p_susan@gmail.com',
    phone: '01 42 22 56 52',
    address: '20 Rue du Cherche-Midi, Gradignan, 75006',
    location: 'Gradignan, France',
    totalOrders: 2,
    totalSpent:890
  },
  {
    id: 7,
    name: 'Elliott Potts',
    avatar: Avatar8,
    email: 'elliott_potts@gmail.com',
    phone: '(403) 210-2149',
    address: 'Suite 1740-1632 14 Ave NW, Calgary, Alberta, T2N 1M7',
    location: 'Alberta, Canada',
    totalOrders: 8,
    totalSpent:2400
  },
  {
    id: 8,
    name: 'Richard Beaudry',
    avatar: Avatar11,
    email: 'richardbeaudry@gmail.com',
    phone: '(416) 640-0930',
    address: '45 Harbour Square, Toronto, Ontario, M5J 2V3',
    location: 'Toronto, Canada',
    totalOrders: 12,
    totalSpent:22325
  },
  {
    id: 9,
    name: 'Henry Saxton',
    avatar: Avatar12,
    email: 'henry_saxton@gmail.com',
    phone: '(604) 224-4699',
    address: '2155 Allison Rd, Vancouver, British Columbia, V6T 1T5',
    location: 'Vancouver, Canada',
    totalOrders: 2,
    totalSpent:240
  },
  {
    id: 10,
    name: 'Juanita Diener',
    avatar:Avatar9,
    email: 'juanita_d123@gmail.com',
    phone: '(951) 360-9941',
    address: '12471 Limonite Ave, Mira Loma, California, 91752',
    location: 'California, United States',
    totalOrders: 9,
    totalSpent:3240
  },
  {
    id: 11,
    name: 'Boris Ortiz',
    avatar:Avatar9,
    email: 'borisortiz@gmail.com',
    phone: '858-834-0897',
    address: '315 Hood Avenue, California, California(CA), 02110',
    location: 'California, United States',
    totalOrders: 8,
    totalSpent:3244
  },
  {
    id: 12,
    name: 'Mr. Stefan Jenkins',
    avatar: Avatar12,
    email: 'stefan_jenkins@gmail.com',
    phone: '(403) 557 8689',
    address: 'Suite 1740-1632 15 Ave NW, Calgary, Alberta, T2N 1M7',
    location: 'Alberta, Canada',
    totalOrders: 7,
    totalSpent:2340
  }
];

export default customersData;